/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }


    /****************** FREE GIFT ******************/
    let correctQuantity = 0;
    // if we're not in US, add E-Book if cart total > 100
    if (cart.total_price > 10000 && country !== "United States") {
        correctQuantity = 1;
    }

    let freeGiftVariantID = 41246464344135;

    // current quantity of free gift
    let currentQuantity = 0;
    let freeGiftItem = cart.items.find(item => item.variant_id === freeGiftVariantID);
    if (freeGiftItem) {
        currentQuantity = freeGiftItem.quantity;
    }

    // if they don't have the free gift, we add the free gift
    if (correctQuantity > 0 && currentQuantity === 0) {
        await addProduct({
            items: [{
                quantity: correctQuantity,
                id: freeGiftVariantID
            }]
        });
        await openCart();
        return;
    }
    // otherwise we update it to the correct quantity
    else if (correctQuantity !== currentQuantity) {
        cart = await updateCart({
            updates: {
                [freeGiftItem.key]: correctQuantity
            }
        });
        await openCart(true);
        return;
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerWrapIconsCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.add("active");
        document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
            element.classList.add("active");
        });
        document.querySelector("#miniCartFooter").classList.remove("active");
        document.querySelector('#miniCartUpsellTitle').textContent = 'Get started with these!';
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector('#miniCartUpsellTitle').textContent = 'You might also like';
    document.querySelector("#miniCartFooter").classList.add("active");

    // Shipping for US
    if (country === "United States") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        const allItemsAreSubscription = cart.items.length > 0 && cart.items.every(item => item.selling_plan_allocation);
        if (cart.total_price >= freeShippingThreshold || allItemsAreSubscription) {
            document.querySelector("#miniCartHeaderBanner").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
            document.querySelector("#miniCartHeaderBanner").innerHTML = `<b>${price(freeShippingThreshold - cart.total_price)} </b> away to unlock <b>FREE SHIPPING</b>`;
        }

        // free shipping if specific items are in cart
        let freeShippingProductIDs = [/*
        7110403162183, // 17-in-1
        7110409191495, // mixed berries
        7110041567303 // capsules
    */];

        // check if cart contains any of the free shipping products
        let isFreeShippingProduct = cart.items.find(item => freeShippingProductIDs.includes(item.product_id));
        if (isFreeShippingProduct) {
            document.querySelector("#miniCartHeaderBanner").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        }
    }

    // Shipping for International
    if (country !== "United States") {
        document.querySelector("#miniCartHeaderBanner").classList.add('small');
        if (cart.total_price >= 1) {
            document.querySelector("#miniCartHeaderBanner").innerHTML = "You've unlocked <b>FREE SHIPPING</b> & <b>MYSTERY GIFT</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / 10000) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
            document.querySelector("#miniCartHeaderBanner").innerHTML = `<b> ${price(10000 - cart.total_price)}</b> away to unlock <b>FREE SHIPPING</b> & <b>MYSTERY GIFT</b>`;
        }

    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            return HTML;
        }


        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <a href="${item.url}" class="miniCartBodyItemLink">
                    <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                </a>
                <div>
                    <div class="miniCartBodyItemFlex">
                        <a href="${item.url}">
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </a>
                        <button class="miniCartBodyItemRemove">
                            <svg class="miniCartCenterBodyItemRowRemoveImg" focusable="false" data-prefix="far" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg aria-hidden="true" class="miniCartCenterBodyItemBottomQtyMinusSVG" focusable="false" data-prefix="far" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"></path></svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"></path></svg>
                            </button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.productId);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // update cart total
    document.querySelector("#miniCartFooterTotalPriceReal").textContent = price(cart.total_price);
    document.querySelector("#miniCartFooterTotalPriceReal").classList.remove("sale");

    document.querySelector("#miniCartFooterTotalPriceCompare").textContent = ``;

    // calculate the maximum compare at price
    let totalComparePrice = 0;
    cart.items.forEach(item => {
        // find variant compare at price
        let comparePrice = variantIDToCompareAtPrice[item.variant_id];
        if (comparePrice > item.original_price) {
            totalComparePrice += comparePrice * item.quantity;
        } else {
            totalComparePrice += item.original_line_price;
        }
    });

    if (totalComparePrice > cart.total_price) {
        document.querySelector("#miniCartFooterTotalPriceCompare").textContent = price(totalComparePrice);
        document.querySelector("#miniCartFooterTotalPriceReal").classList.add("sale");
        document.querySelector("#miniCartFooterSavingsPrice").textContent = price(totalComparePrice - cart.total_price);
    }

    // update savings text
    document.querySelector("#miniCartFooterSavings").classList.remove('active')
    if (document.querySelector("#miniCartFooterSavings").classList.contains('enabled') && totalComparePrice > cart.total_price) {
        document.querySelector("#miniCartFooterSavings").classList.add('active')
        document.querySelector("#miniCartFooterSavingsPrice").textContent = price(totalComparePrice - cart.total_price);
    }


    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterTotalPriceReal").textContent = price(cart.total_price + cartSettings.protection_upsell.variants[0].price);
    } else {
        document.querySelector("#miniCartFooterTotalPriceReal").textContent = price(cart.total_price);
    }

}





// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});

// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC.new').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

    });
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}